enum InfoButtonText {
    DEFAULT = "Info",
    NTB = "NTB",
    HTB = "HTB",
    UUT = "UUT",
    GB = "Genesis Blk",
    BLOCK = "Block"
}

export { InfoButtonText }